var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5H5.5625L13.375 7.6875L12.3125 6.625L4.5 14.4375V15.5ZM3 17V13.8125L13.375 3.4375C13.5278 3.28472 13.6933 3.17361 13.8717 3.10417C14.0499 3.03472 14.2374 3 14.4342 3C14.6308 3 14.8194 3.03472 15 3.10417C15.1806 3.17361 15.3472 3.28472 15.5 3.4375L16.5625 4.5C16.7153 4.65278 16.8264 4.81944 16.8958 5C16.9653 5.18056 17 5.36486 17 5.55292C17 5.75361 16.9651 5.94486 16.8954 6.12667C16.8257 6.30847 16.7147 6.47458 16.5625 6.625L6.1875 17H3ZM12.8344 7.16563L12.3125 6.625L13.375 7.6875L12.8344 7.16563Z",
    fill: "#3F41D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEdit);
export default __webpack_public_path__ + "static/media/content-edit.a4c9de61d76c5d83ea6b65513ff4aac2.svg";
export { ForwardRef as ReactComponent };